<template>

  <v-container class="fluid">
  <v-row justify="center" align="center">
    <v-col cols="3" class="text-center center">
      <v-btn text v-if="action==='preview_video' && !isPlaying" class="mr-1" small @click="$emit('preview_video')" :disabled="disabled">
        <v-icon color="white">mdi-play</v-icon>
        {{$t('components.video_control.play')}}
      </v-btn>
      <v-btn text v-if="action==='preview_video' && isPlaying" class="mr-1" small @click="$emit('preview_video_pause')" :disabled="disabled">
        <v-icon color="white">mdi-pause</v-icon>
        {{$t('components.video_control.pause')}}
      </v-btn>
      <v-btn text v-if="action==='start_recording'" small class="mr-1" @click="$emit('start_recording')" :disabled="disabled">
        <v-icon color="red">mdi-record</v-icon>
        {{$t('components.video_control.start')}}
      </v-btn>
      <v-btn text v-if="action==='stop_recording'" small class="mr-1" @click="$emit('stop_recording')" :disabled="disabled">
        <v-icon color="white">mdi-stop</v-icon>
        {{$t('components.video_control.stop')}}
      </v-btn>
    </v-col>
    <v-col :cols="attempts > 1 ? 5 : 8" class="text-center">
      <v-row>
        <v-col cols="10" class="pa-0 center" style="position: relative"
        >
<!--          <transition name="slide-x-reverse-transition">-->
          <div
              v-show="ready && action!=='preview_video'"
               ref="minimumTimeLine"
               class="min-seconds-indicator"
               :style="'left:'+minimumTimeLineLocation+'px'"
          >
            <div style="height:15px; width:1px; border: 1px solid white"></div>
            <small>{{$t('components.video_control.minimum')}} {{minSeconds | formatSeconds}}</small>
          </div>
<!--          </transition>-->
          <v-progress-linear ref="progressBar" color="accent"
                             :buffer-value="calculatedBuffered"
                             :stream="calculatedStream"
                             :value="calculatedProgress"
                             height="10"
                             style="border-radius: 10px"
                             @click="seek($event)"
                             :class="{'pointer':isPlaying}">

          </v-progress-linear>
        </v-col>
        <v-col cols="2" class="pa-0 center">
          <small v-if="progress <= 1">{{maxSeconds | formatSeconds}}</small>
          <small v-else :class="[countdownColor?countdownColor+'--text':null]">{{(maxSeconds - progress) | formatSeconds}}</small>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="3" v-if="attempts > 1">
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
              v-on="on"
              text
              small
              :disabled="action==='stop_recording' || disabled"
          >
            {{$t('components.video_control.attempt_str',{num:$t_num(calculatedAttemptNumber),total:$t_num(attempts)})}}
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item
            v-for="(video,idx) in responsevideos"
            :key="video.responsevideoid"
            @click="switchVideo(video)"
            :input-value="video.final"
          >
            <v-list-item-content>
              <v-list-item-title>{{$t('components.video_control.attempt_str',{num:idx+1,total:$t_num(attempts)})}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-col>
    <v-col cols="1" v-if="attempts > 1">
      <v-btn :disabled="disabled" icon color="red" @click="$emit('retry')" v-if="currentAttempt<attempts && currentAttempt>0">
       <!-- <v-icon small>mdi-refresh</v-icon>-->
        {{$t('general.retry')}}
      </v-btn>
    </v-col>
  </v-row>
  </v-container>
</template>

<script>
  export default {
    name: "VideoResponseControls",
    props: {
      action: {
        type: String, // preview_video | start_recording | stop_recording
        required: true
      },
      attempts: {
        type: Number,
        default: 0
      },
      currentAttempt: {
        type: Number,
        default: 0
      },
      minSeconds: {
        type: Number,
        default: 0
      },
      maxSeconds: {
        type: Number,
        required: true
      },
      progress: {
        type: Number,
        default: 0
      },
      buffered: {
        type: Number,
        default: 0
      },
      disabled: {
        type: Boolean,
        default: false
      },
      countdownColor: {
        type: String,
        default: 'white'
      },
      isPlaying: {
        type:Boolean,
        default: false
      },
      value:{},
      responsevideos:{type:Array, default:()=>[]},
    },
    data(){
      return {
        init:false,
        minimumTimeLineLocation:0,
        ready:false,
      }
    },
    computed:{
      calculatedProgress(){
        if(this.progress <= 0 || this.maxSeconds <= 0) return 0;

        return (this.progress / this.maxSeconds) * 100;
      },
      calculatedBuffered(){
        if(this.action!=='preview_video'){
          return undefined;
        }
        if(this.progress===0){
          return 100;
        }
        return (this.buffered / this.maxSeconds) * 100;
      },
      calculatedStream(){
        return this.action==='preview_video' && this.progress > 0;
      },
      calculatedAttemptNumber(){
        if(this.action!=='preview_video' || !this.responsevideos || !this.value){
          return this.currentAttempt;
        }
        let cnt=1;
        for(let attempt of this.responsevideos){
          if(this.value && this.value.responsevideoid===attempt.responsevideoid){
            return cnt;
          }
          cnt++;
        }
        return this.currentAttempt;
      }
    },
    watch:{
      minSeconds(){
        this.calculateMinimumTimeLineLocation();
      },
      maxSeconds(){
        this.calculateMinimumTimeLineLocation();
      },
      action(){
        this.calculateMinimumTimeLineLocation();
      }
    },
    methods:{
      calculateMinimumTimeLineLocation(){ //werk nie in computed nie hy tel nie window resize op nie
        if(this.$refs.progressBar == null) {this.minimumTimeLineLocation = 0; return;}

        let direction = this.$vuetify.rtl ? 'right' : 'left';

        let startingPoint = -24;
        const progressBarLength = parseFloat(this.$refs.progressBar.$el.clientWidth);

        const min = this.minSeconds;
        const max = this.maxSeconds ? this.maxSeconds : 300
        let perc = min/max;

          if(direction === 'right'){
              perc = 1 - perc;
          }

        //Adjust the line a little in account for progress curvature
        if(min === max) {
            if(direction === 'right'){
                startingPoint = -20;
            }else{
                startingPoint = -15;
            }
        }else if(min <= 0){
            if(direction === 'right'){
                startingPoint = -16;
            }else{
                startingPoint = -20;
            }
        }

        let minimumTimeLineLocation = (perc * progressBarLength)
        this.$set(this, 'minimumTimeLineLocation', startingPoint + minimumTimeLineLocation);

        if(!this.ready) {
          setTimeout(()=>{
            this.ready=true; this.calculateMinimumTimeLineLocation();
          },200);
        }
      },
      seek(event){
        if(!this.isPlaying) return;
        const clickX=event.offsetX;
        const totalX=event.target.getBoundingClientRect().width;
        const seek=clickX/totalX;
        this.$emit('seek',seek);
      },
      switchVideo(video){
        if(video.responsevideoid!==this.value.responsevideoid || this.action!=='preview_video'){
          this.$emit('switch-responsevideo',video);
        }
      }
    },
    filters: {
      formatSeconds(s) {
        if (s == null || !s || s === 0) return '00:00';

        return (s - (s %= 60)) / 60 + (9 < s ? ':' : ':0') + s
      }
    },
    beforeDestroy(){
      window.removeEventListener("resize", this.calculateMinimumTimeLineLocation);
    },
    mounted(){

      this.calculateMinimumTimeLineLocation();

      setTimeout(()=>{
        this.calculateMinimumTimeLineLocation();
      },400);

      window.addEventListener("resize", this.calculateMinimumTimeLineLocation);

      if(this.maxSeconds < this.minSeconds)
        throw new DOMException('Min seconds cannot be greater than max seconds');
    }
  }
</script>

<style scoped>
  .center {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .min-seconds-indicator {
    position:absolute; display: flex; align-items: center; flex-direction: column; top:3px; z-index: 100;
  }

  .pointer{
    cursor: pointer;
  }
</style>
